var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{staticClass:"edit-delivery",attrs:{"paddingMainContents":false}},[_c('Panel',{staticClass:"text-blue-800",attrs:{"title":"แก้ไขรายการจัดส่ง"}},[_c('CommonFormWithDeliveryEditor',{attrs:{"edit":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }